module.exports = __webpack_public_path__ + "img/q2-b.39e83490.jpg";